import React from 'react';
import type {
  ListAssetViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

export const ListAssetsView = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/ListAssets')),
);

export const ListAssetsViewView = (props: ListAssetViewProps) => (
  <div className="grow">
    <ListAssetsView {...props.data} />
  </div>
);
